var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M6.6665 12.2667H10.6665V25.3334H6.6665V12.2667ZM14.1332 6.66675H17.8665V25.3334H14.1332V6.66675ZM21.5998 17.3334H25.3332V25.3334H21.5998V17.3334Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }